import {
	getBuildingsListFiltersState,
	getComfortFiltersState,
	getTechStatusFiltersState,
	getTenantsListFiltersState,
} from '@app/pages/dashboard/state/dashboard.selectors';
import {
	searchDashboardBuildings,
	searchDashboardTenants,
	searchDashboardZones,
	storeComfortFilters,
	storeTechStatusFilters,
} from '@app/pages/dashboard/state/dashboard.actions';
import { MemoizedSelector } from '@ngrx/store';
import {
	AssetsBuildingFilterFields,
	BuildingComfortFields,
	BuildingTechStatusField,
	DashboardBuildingFilterFields,
} from '@app/configs/filters/filters-fileds.config';
import { IAuFilterFieldsConfig } from '@shared/ui-components/au-configurable-filter/interfaces/au-configurable-filter.interfaces';
import { getAssetsBuildingsFiltersState } from '@app/pages/settings/portfolio/state/area-assets.selectors';
import { searchAssetsBuildings } from '@app/pages/settings/portfolio/state/area-assets.actions';

/**
 * For adding new filter you need to:
 * 1) Add filter name to AuFilterNameType
 * 2) Add option fields if needed to AuFilterOptionsListName
 * 3) Add implementation of this options to au-configurable-filters.service
 * 4) Add new filter field config to filters-fields.config
 * 5) Register fields config, state selector and changing action to AuFiltersGlobalConfig
 */

export interface IAuFiltersConfig {
	fieldsConfig: IAuFilterFieldsConfig;
	filterStateSelector$: MemoizedSelector<any, any, (t: any) => any>;
	changeFilterToStoreAction: (t: any) => any;
}

const assetsBuildings = {
	fieldsConfig: AssetsBuildingFilterFields,
	filterStateSelector$: getAssetsBuildingsFiltersState,
	changeFilterToStoreAction: searchAssetsBuildings,
};

const dashboardBuildings = {
	fieldsConfig: DashboardBuildingFilterFields,
	filterStateSelector$: getBuildingsListFiltersState,
	changeFilterToStoreAction: searchDashboardBuildings,
};

const dashboardZones = {
	fieldsConfig: DashboardBuildingFilterFields,
	filterStateSelector$: getBuildingsListFiltersState,
	changeFilterToStoreAction: searchDashboardZones,
};

const dashboardTenants = {
	fieldsConfig: DashboardBuildingFilterFields,
	filterStateSelector$: getTenantsListFiltersState,
	changeFilterToStoreAction: searchDashboardTenants,
};

const buildingComfort = {
	fieldsConfig: BuildingComfortFields,
	filterStateSelector$: getComfortFiltersState,
	changeFilterToStoreAction: storeComfortFilters,
};

const buildingTechStatus = {
	fieldsConfig: BuildingTechStatusField,
	filterStateSelector$: getTechStatusFiltersState,
	changeFilterToStoreAction: storeTechStatusFilters,
};

export type AuFilterNameType =
	| 'assetsBuildings'
	| 'dashboardBuildings'
	| 'dashboardZones'
	| 'dashboardTenants'
	| 'buildingComfort'
	| 'buildingTechStatus';

export const AuFiltersGlobalConfig: {
	[key in AuFilterNameType]: IAuFiltersConfig;
} = {
	assetsBuildings,
	dashboardBuildings,
	dashboardZones,
	dashboardTenants,
	buildingComfort,
	buildingTechStatus,
};
